import { forwardRef } from 'react';
import { FormCPF, FormCNPJ } from '../FormMaskedInputs';
import FormInput from '../FormInput';
import type { ComponentPropsWithoutRef } from 'react';

// ============================================
// Document Types - Internal Types do Backend
// ============================================

// DocumentNumber (CPF, CNPJ, etc with validation)
interface DocumentNumberProps {
    country?: string;
    documentType?: 'CPF' | 'CNPJ' | 'DNI' | 'SSN' | 'NIF' | string;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

export const DocumentNumber = forwardRef<HTMLInputElement, DocumentNumberProps>(({ country = 'BRA', documentType = 'CPF', value, onChange, disabled, className = '' }, ref) => {
    // For Brazilian documents, use specific masked inputs
    if (country === 'BRA') {
        if (documentType === 'CPF') {
            return <FormCPF ref={ref} value={value} onChange={(normalized) => onChange?.(normalized)} disabled={disabled} className={className} />;
        }
        if (documentType === 'CNPJ') {
            return <FormCNPJ ref={ref} value={value} onChange={(normalized) => onChange?.(normalized)} disabled={disabled} className={className} />;
        }
    }

    // For other countries/documents, use generic input
    return <FormInput ref={ref} type="text" value={value} onChange={(e) => onChange?.(e.target.value)} disabled={disabled} className={className} placeholder={`${documentType} (${country})`} />;
});
DocumentNumber.displayName = 'DocumentNumber';

// DocumentNumberCPF (Brazilian CPF)
interface DocumentNumberCPFProps {
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

export const DocumentNumberCPF = forwardRef<HTMLInputElement, DocumentNumberCPFProps>((props, ref) => {
    return <FormCPF {...props} ref={ref} />;
});
DocumentNumberCPF.displayName = 'DocumentNumberCPF';

// DocumentNumberCNPJ (Brazilian CNPJ)
interface DocumentNumberCNPJProps {
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

export const DocumentNumberCNPJ = forwardRef<HTMLInputElement, DocumentNumberCNPJProps>((props, ref) => {
    return <FormCNPJ {...props} ref={ref} />;
});
DocumentNumberCNPJ.displayName = 'DocumentNumberCNPJ';
